import { z } from 'zod';
import { buildApiMutationHook } from '../utils/api';
import axiosI from './base.api';

export const AdminSchema = z.object({
  id: z.number(),
  email: z.string(),
  updatedAt: z.string(),
  createdAt: z.string(),
});

export type AdminAttributes = z.infer<typeof AdminSchema>;

export type AdminLoginParams = {
  email: string;
  password: string;
};

export type AdminLoginResponse = {
  admin: AdminAttributes;
  accessToken: string;
};

export const useAdminLogin = buildApiMutationHook<AdminLoginParams, AdminLoginResponse>((params) =>
  axiosI.post('/admin/login', params),
);
